function verifica_autenticado() {
    const access = localStorage.getItem('access')
    const refresh = localStorage.getItem('refresh')

    if(access === null || refresh === null) {
        return false
    } else {
        return true
    }
}

export default verifica_autenticado;
